import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'fgb-rewards-layout',
  templateUrl: './rewards-layout.component.html',
  styleUrls: ['./rewards-layout.component.css'],
})
export class RewardsLayoutComponent {
  readonly routes = ['marketplace', 'events', 'raffles', 'auctions', 'wallet'];
  bannerText: string = '';

  selectedIndex = 0;
  hideNav: boolean = false;
  isWalletRoute: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.hideNav = this.isDetailLikeUrl(this.router.url);
    this.isWalletRoute = this.router.url.split('?')[0] === '/rewards/wallet';

    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.hideNav = this.isDetailLikeUrl(event.urlAfterRedirects);

      const current = this.route.firstChild?.snapshot.routeConfig?.path;
      const index = this.routes.indexOf(current ?? 'marketplace');
      this.selectedIndex = index >= 0 ? index : 0;
      this.isWalletRoute = current === 'wallet';
    });
  }

  private isDetailLikeUrl(url: string): boolean {
    const segments = this.router.parseUrl(url).root.children['primary']?.segments ?? [];
    const paths = segments.map((segment) => segment.path);

    return segments.length > 2 || paths.includes('claimed');
  }

  onTabChange(index: number) {
    this.bannerText = this.routes[index] + '.page.title';
    this.router.navigate([this.routes[index]], {
      relativeTo: this.route,
    });
  }
}
